import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProducts } from "../api";
import ProductCard from "./ProductCard";
import { Loader2 } from "lucide-react";

const FeaturedProducts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts({ featured: true })
      .then((data) => setItems(data.slice(0, 8)))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="relative py-28 lg:py-40 bg-[var(--ivory)] vc-grain" data-testid="featured-products">
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-20 z-[2]">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
          <div className="vc-fade-up">
            <p className="vc-eyebrow text-[var(--copper)] mb-6">N°01 · The Collection</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.08] text-[var(--espresso)] max-w-xl">
              Objects from the <em className="italic text-[var(--copper)]">studio</em>.
            </h2>
            <p className="mt-6 text-[var(--espresso)]/60 leading-[1.9] max-w-md">
              A rotating selection of signature pieces — each limited, each quietly made.
            </p>
          </div>
          <Link
            to="/shop"
            data-testid="featured-view-all"
            className="text-[11px] tracking-[0.28em] uppercase text-[var(--espresso)] vc-link-underline self-start md:self-end"
          >
            View all pieces →
          </Link>
        </div>

        {loading ? (
          <div className="py-16 flex justify-center">
            <Loader2 className="w-6 h-6 animate-spin text-[var(--copper)]" />
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
            {items.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedProducts;
